/**
 *
 * @param queryParam
 * @param pageIndex
 * @returns {Promise<any>}
 */
export default function getPopularCategoryPosts( queryParam = '', pageIndex = 1 ) {
  const query = queryParam ? `&tag=${queryParam}` : '';
  const requestURL = `https://api.parsely.com/v2/top/posts?apikey=adweek.com&days=30${query}`;

  return fetch(requestURL)
    .then( response => response.json() )
	  .catch( err => {
	    console.error( 'Developer message: Error in fetching parsley popular posts data: ' + err );
  } );
}

